// Hide empty or automatic names (only numbers, e.g. "12" or "IMG 3371")
const AUTO_NAME = /^\s*(img|image|imagem|foto|photo|dsc|ds|screenshot|sticker|figurinha|copia|copy)?[\s\d_.()-]*$/i;

export const displayName = (name) => (!name || AUTO_NAME.test(name) ? "" : name.trim());
